module.exports = __webpack_public_path__ + "img/logo_bouygue_enterprise_blanc.290b7832.svg";